import { Box, Button, styled } from '../../base';

export const ViewerContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    minHeight: 600,
    position: 'relative',
}));

export const DocContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    background: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
}));

export const OverlayControls = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 12,
    left: 12,
    display: 'flex',
    gap: theme.spacing(1),
    zIndex: 10,
    pointerEvents: 'auto',
}));

export const FullscreenBody = styled(Box)(({ theme }) => ({
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    marginTop: theme.spacing(2),
}));

export const ActionButton = styled(Button)(({ theme }) => ({
    background: theme.palette.grey[500],
    minWidth: 40,
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50%',
    color: theme.palette.common.white,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',

    '&:hover': {
        background: theme.palette.grey[600],
    },
}));
